<template>
    <section class="user">
        <div class="row">
            <div class="col grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 v-if="$attrs.mode === 'new'">{{ $t('createNewTitle') }}</h4>
                        <h4 v-else class="card-title">{{ $t('editEntry') }} <strong>{{itemName}}</strong> <code>(id {{item.id}})</code></h4>
                        <p class="card-description pb-4">{{ $t('fillFieldsBelow') }}</p>
                        <div class="forms-sample">
                            <div class="row">
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.username')" label-for="username-input">
                                        <b-form-input type="text" id="username-input" :placeholder="$t('forms.email')" v-model="item.email" :state="emailState" :disabled="isEditMode"/>
                                    </b-form-group>
                                </div>
                              <div  v-if="!isEditMode" class="col-lg-3">
                                <b-form-group :label="$t('forms.password')" label-for="password-input">
                                  <b-form-input type="password" id="password-input" :placeholder="$t('forms.password')" v-model="item.password" :state="passwordState"/>
                                </b-form-group>
                              </div>
                                <div class="col-lg-3">
                                    <b-form-group :label="$t('forms.role')" label-for="role-input">
                                        <b-form-select v-model="item.role.id" :options="roles" value-field="id" text-field="displayName" :state="roleState" :disabled="isEditMode"/>
                                    </b-form-group>
                                </div>
                                <div class="col my-auto">
                                    <b-form-group :label="$t('forms.passwordChangeRequired')">
                                        <b-form-checkbox v-model="item.forcePasswordChange" name="check-button" switch size="lg" :disabled="true">
                                            <p v-text="item.forcePasswordChange ? $t('forms.yes') : $t('forms.no')" style="margin-top: 4px;" class="pl-2" />
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                            </div>

                            <b-button v-if="!isEditMode" variant="success" class="mr-2" @click="saveItem" :disabled="validated">{{ $t('forms.save') }}</b-button>
                            <b-button variant="light" v-on:click="cancel">{{ $t('forms.cancel') }}</b-button>
                            <b-button v-if="isEditMode" variant="danger" class="float-right" :disabled="isSelfEditing" v-b-modal.confirm-delete>{{ $t('forms.delete') }}</b-button>
                        </div>
                    </div>
                  <hr/>
                  <h5 class="card-body">{{ $t('roles.description') }}</h5>
                  <b-list-group class="card-body mb-4">
                    <b-list-group-item>
                      <h6 class="mb-1">{{ $t('roles.superAdmin') }}</h6>
                      <p class="mb-0 text-gray">{{ $t('roles.superAdminDescription') }}</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <h6 class="mb-1">{{ $t('roles.admin') }}</h6>
                      <p class="mb-0 text-gray">{{ $t('roles.adminDescription') }}</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <h6 class="mb-1">{{ $t('roles.cms') }}</h6>
                      <p class="mb-0 text-gray">{{ $t('roles.cmsDescription') }}</p>
                    </b-list-group-item>

                    <b-list-group-item>
                      <h6 class="mb-1">{{ $t('roles.orders') }}</h6>
                      <p class="mb-0 text-gray">{{ $t('roles.ordersDescription') }}</p>
                    </b-list-group-item>
                  </b-list-group>
                </div>
            </div>
        </div>
        <b-modal id="confirm-delete" :title="$t('forms.warning')" size="md" header-bg-variant="danger" header-text-variant="light" :cancelTitle="$t('forms.cancel')" :okTitle="$t('forms.delete')" @ok="deleteItem">
            <p class="text-center">{{ $t('forms.deleteConfirmationMessage') }}</p>
        </b-modal>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../main'
    import jwtService from "../../../mixins/JwtStorageService";

    export default {
        name: 'User',
        computed: {
            emailState() {
                let email = this.item.email
                if (typeof email !== "string") return false;
                const value = email.trim();

                if (value.length === 0 || value.length > 254) return false;

                const at = value.indexOf("@");
                if (at <= 0 || at !== value.lastIndexOf("@") || at === value.length - 1) return false;

                const [local, domain] = value.split("@");

                if (local.length > 64) return false;
                if (local.startsWith(".") || local.endsWith(".") || local.includes("..")) return false;
                const localRe = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
                if (!localRe.test(local)) return false;

                const domainRe =
                    /^(?=.{1,253}$)(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
                return domainRe.test(domain);
            },
            passwordState() {
                if (this.item.password) {
                    return this.item.password.length > 0
                } else {
                    return false
                }
            },
            roleState() {
                if (this.item.role) {
                    return this.item.role.id > -1
                } else {
                    return false
                }
            },
            validated() {
                return !this.emailState || !this.passwordState || !this.roleState
            }
        },
        data() {
            return {
                lang: Const.LANG,
                roles: [],
                item: {},
                itemName: '',
                isSelfEditing: false,
                isEditMode: this.$attrs.mode === Const.MODE_EDIT,
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/roles')
                .then(function (response) {
                    return response.data
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            }).then(body => {
                this.roles = body
                this.roles = this.roles.map(item => ({
                  ...item,
                  displayName: this.humanRole(item.name),
                }));
            })
            if (this.$attrs.mode === Const.MODE_EDIT) {
                axios.get(Const.API_HOST + '/admin/users/get', {
                    params: {
                        'id': this.$route.params.id
                    }
                }).then(function (response) {
                    return response.data
                }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                }).then(body => {
                    this.item = body
                    this.itemName = JSON.parse(JSON.stringify(this.item.email))
                    this.isSelfEditing = jwtService.getUsername() === this.item.email
                })
            } else {
                this.item = {
                    email: '',
                    role: {},
                    forcePasswordChange: true,
                }
            }
        },
        methods: {
            humanRole(value) {
              if (value === 'ROLE_ADMIN') {
                return this.$t('roles.admin')
              } else if (value === 'ROLE_ORDERS') {
                return this.$t('roles.orders')
              } else if (value === 'ROLE_CMS_ADMIN') {
                return this.$t('roles.cms')
              } else if (value === 'ROLE_SUPER_ADMIN') {
                return this.$t('roles.superAdmin')
              } else {
                return this.$t('roles.unknown')
              }
            },
            cancel() {
                this.$router.push('/users')
            },
            saveItem() {
                var app = this
                axios.post(Const.API_HOST + '/admin/users/register', {
                    email: this.item.email,
                    password: this.item.password,
                    roleId: this.item.role.id
                }).then(function (response) {
                  // eslint-disable-next-line no-console
                  console.log(response)
                  if (response.status === 200) {
                    app.$router.push('/users')
                  }
                }).catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log(error)
                })

            },
            deleteItem() {
                var app = this
                axios.post(Const.API_HOST + '/admin/users/remove', {
                    email: this.item.email
                }).then(function (response) {
                  // eslint-disable-next-line no-console
                  console.log(response)
                  if (response.status === 200) {
                    app.$router.push('/users')
                  }
                }).catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log(error)
                })
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }
</style>
